export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13598.90282ce2.jpg";